<template>
  <i
    v-if="browser?.toLowerCase() === 'ie'"
    class="fa-brands fa-internet-explorer"
  ></i>
  <img
    v-else-if="browser?.toLowerCase() === 'coccoc'"
    src="/coccoc.png"
    alt="CocCoc"
    class="size-full object-contain"
  />
  <i v-else :class="`fa-brands fa-${browser?.toLowerCase()}`"></i>
</template>
<script setup lang="ts">
defineProps<{
  browser: string | undefined;
}>();
</script>
